/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  codigoLead: string;
}

export function useTransferirLead() {
  const postData = async (props: Props) => {
    const TRANSFERIR_LEAD = `${backofficeEnviroment}/common/oportunidades-lead/transferir-lead/v1`;
    const { data } = await instance.put(TRANSFERIR_LEAD, {
      idProposta: props.idOportunidade,
      codigoLead: props.codigoLead,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Proposta transferida com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao transferir proposta. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
